import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import Scrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import packageJson from "../../../package.json";
import logo from "../../assets/img/others/logo.png";

function Sidenavigation(props) {
  const authPermission = localStorage.getItem("PermissionDetails");
  const [dashboardHide, setDashboardHide] = useState(true);
  const [reportHide, setReportHide] = useState(true);
  const [orderHide, setorderHide] = useState(true);
  const [billPrintHide, setBillPrintHide] = useState(true);
  const [orderReportHide, setOrderReportHide] = useState(true);
  const [totalSaleReportHide, setTotalSaleReportHide] = useState(true);
  const [permissionHide, setPermissionHide] = useState(true);
  const [adminHide, setAdminHide] = useState(true);
  const [paymentHide, setPaymentHide] = useState(true);
  const [productHide, setproductHide] = useState(true);
  const [userHide, setUserHide] = useState(true);
  const [catHide, setCatHide] = useState(true);
  const [bannerHide, setBannerHide] = useState(true);
  const [settingHide, setSettingHide] = useState(true);
  const [currierPriceHide, setCurrierPriceHide] = useState(true);
  const [currierCompanyHide, setCurrierCompanyHide] = useState(true);
  const [productReviewHide, setProductReviewHide] = useState(true);
  const [flashSaleHide, setFlashSaleHide] = useState(true);
  const [stockHide, setStockHide] = useState(true);
  const [subjectHide, setSubjectHide] = useState(true);
  const [mediumHide, setMediumHide] = useState(true);
  const [publisherHide, setPublisherHide] = useState(true);
  const [grnHide, setGrnHide] = useState(true);
  const [gdnHide, setGdnHide] = useState(true);
  const [order2Hide, setOrder2Hide] = useState(true);
  const [profitReportHide, setProfitReportHide] = useState(true);
  const [stockSummaryHide, setStockSummaryHide] = useState(true);
  const [dashboardReportHide, setDashboardReportHide] = useState(false);



  useEffect(() => {
    JSON.parse(authPermission).forEach(function (loca) {
      // Hide dashboard-report for SALES_USER and STORE_USER
      if (loca.access_level.access_level === "SALES_USER" || loca.access_level.access_level === "STORE_USER") {
        setDashboardReportHide(true);
      }
      
      if (
        loca.access_module.module_name == "ORDERS" &&
        loca.permission_view === true
      ) {
        setorderHide(false);
      } else if (
        loca.access_module.module_name == "DASHBOARD" &&
        loca.permission_view === true
      ) {
        setDashboardHide(false);
      } else if (
        loca.access_module.module_name == "REPORT" &&
        loca.permission_view === true
      ) {
        setReportHide(false);
      } else if (
        loca.access_module.module_name == "PERMISSION" &&
        loca.permission_view === true
      ) {
        setPermissionHide(false);
      } else if (
        loca.access_module.module_name == "SYSTEM_USER" &&
        loca.permission_view === true
      ) {
        setAdminHide(false);
      } else if (
        loca.access_module.module_name == "PAYMENT_LOG" &&
        loca.permission_view === true
      ) {
        setPaymentHide(false);
      } else if (
        loca.access_module.module_name == "PRODUCTS" &&
        loca.permission_view === true
      ) {
        setproductHide(false);
      } else if (
        loca.access_module.module_name == "USERS" &&
        loca.permission_view === true
      ) {
        setUserHide(false);
      } else if (
        loca.access_module.module_name == "CATEGORIES" &&
        loca.permission_view === true
      ) {
        setCatHide(false);
      } else if (
        loca.access_module.module_name == "BANNERS" &&
        loca.permission_view === true
      ) {
        setBannerHide(false);
      } else if (
        loca.access_module.module_name == "SETTINGS" &&
        loca.permission_view === true
      ) {
        setSettingHide(false);
      } else if (
        loca.access_module.module_name == "CURRIER_PRICE" &&
        loca.permission_view === true
      ) {
        setCurrierPriceHide(false);
      } else if (
        loca.access_module.module_name == "CURRIER_COMPANY" &&
        loca.permission_view === true
      ) {
        setCurrierCompanyHide(false);
      } else if (
        loca.access_module.module_name == "PRODUCT_REVIEW" &&
        loca.permission_view === true
      ) {
        setProductReviewHide(false);
      } else if (
        loca.access_module.module_name == "FLASH_SALES" &&
        loca.permission_view === true
      ) {
        setFlashSaleHide(false);
      } else if (
        loca.access_module.module_name == "STOCKS" &&
        loca.permission_view === true
      ) {
        setStockHide(false);
      } else if (
        loca.access_module.module_name == "SUBJECT" &&
        loca.permission_view === true
      ) {
        setSubjectHide(false);
      } else if (
        loca.access_module.module_name == "MEDIUM" &&
        loca.permission_view === true
      ) {
        setMediumHide(false);
      } else if (
        loca.access_module.module_name == "PUBLISHER" &&
        loca.permission_view === true
      ) {
        setPublisherHide(false);
      } else if (
        loca.access_module.module_name == "INCOMING_INVOICE" &&
        loca.permission_view === true
      ) {
        setGrnHide(false);
      } else if (
        loca.access_module.module_name == "DISPATCH" &&
        loca.permission_view === true
      ) {
        setGdnHide(false);
      }else if (
        loca.access_module.module_name == "BILL_ORDERS" &&
        loca.permission_view === true
      ) {
        setBillPrintHide(false);
      }else if (
        loca.access_module.module_name == "ORDER_2" &&
        loca.permission_view === true
      ) {
        setOrder2Hide(false);
      }else if (
        loca.access_module.module_name == "ORDER_REPORT" &&
        loca.permission_view === true
      ) {
        setOrderReportHide(false);
      }else if (
        loca.access_module.module_name == "TOTAL_SALE_REPORT" &&
        loca.permission_view === true
      ) {
        setTotalSaleReportHide(false);
      }else if (
        loca.access_module.module_name == "STOCK_SUMMARY" &&
        loca.permission_view === true
      ) {
        setStockSummaryHide(false);
      }
      
    });
  }, [authPermission]);

  const removeoverlay = () => {
    $(".ms-body").toggleClass("ms-aside-left-open");
    $("#ms-side-nav").toggleClass("ms-aside-open");
    $(".ms-aside-overlay.ms-overlay-left").toggleClass("d-block");
  };

  useEffect(() => {
    function setActiveMenuItem() {
      // Remove any existing event listeners to prevent duplicates
      $(".ms-main-aside .menu-item > a.has-chevron").off("click");
      
      $(".ms-main-aside .menu-item > a.has-chevron").on("click", function (e) {
        e.preventDefault(); // Prevents link navigation
        e.stopPropagation(); // Prevents event bubbling
        
        var element = $(this).parent("li");
        var isActive = element.hasClass("active");
        
        // Close all other menu items first
        $(".ms-main-aside .menu-item").not(element).removeClass("active");
        $(".ms-main-aside .menu-item").not(element).find("li").removeClass("active");
        $(".ms-main-aside .menu-item").not(element).find(".collapse").slideUp();
        
        // Toggle current menu item
        if (isActive) {
          element.removeClass("active");
          element.find("li").removeClass("active");
          element.find(".collapse").slideUp();
        } else {
          element.addClass("active");
          element.children(".collapse").slideDown();
        }
      });
    }
    
    // Add a small delay to ensure DOM is ready
    const timer = setTimeout(() => {
      setActiveMenuItem();
    }, 100);
    
    return () => {
      clearTimeout(timer);
      // Clean up event listeners on unmount
      $(".ms-main-aside .menu-item > a.has-chevron").off("click");
    };
  }, []);

  return (
    <div>
      <div
        className="ms-aside-overlay ms-overlay-left ms-toggler"
        onClick={removeoverlay}
      ></div>
      <div className="ms-aside-overlay ms-overlay-right ms-toggler"></div>
      <Scrollbar
        id="ms-side-nav"
        className="side-nav fixed ms-aside-scrollable ms-aside-left"
      >
        {/* Logo */}
        <div className="logo-sn ms-d-block-lg">
          <Link className="pl-0 ml-0 text-center" to={dashboardReportHide ? "/orders" : "/dashboard-report"}>
            <img src={logo} alt="logo" />
          </Link>
        </div>
        {/* Navigation */}
        <ul className="accordion ms-main-aside fs-14" id="side-nav-accordion">
          {/* Dashboard */}
          {/* <li className="menu-item" hidden={dashboardHide}>
            <Link to="/dashboard-report">
              {" "}
              <span>
                <i className="material-icons fs-16">dashboard</i>Dashboard{" "}
              </span>
            </Link>
          </li> */}
          {/* /dashboard-report */}

          {/* Dashboard Report*/}
          <li className="menu-item" hidden={dashboardReportHide}>
            <Link to="/dashboard-report">
              {" "}
              <span>
              <i className="fa fa-paste fs-16" />
                Dashboard Report{" "}
              </span>
            </Link>
          </li>
          {/* Dashboard Report*/}

          {/* Alt Profit Report*/}
          <li className="menu-item" hidden={profitReportHide}>
            <Link to="/profit-report">
              {" "}
              <span>
              <i className="fa fa-paste fs-16" />
                Profit Report{" "}
              </span>
            </Link>
          </li>
          {/* Alt Profit Report*/}

          {/* Pending orders */}
          {/* <li className="menu-item" hidden={orderHide}>
            <Link to="/pendingorder">
              <span>
                <i className="fas fa-clipboard-list fs-16" />
                Pending Orders
              </span>
            </Link>
          </li> */}
          {/* Pending orders end */}

          {/* orders */}
          <li className="menu-item" hidden={orderHide}>
            <Link to="/orders">
              <span>
                <i className="fas fa-clipboard-list fs-16" />
                Orders
              </span>
            </Link>
          </li>
          {/* orders end */}

          {/* orders */}
          <li className="menu-item" hidden={order2Hide}>
            <Link to="/orders">
              <span>
                <i className="fas fa-clipboard-list fs-16" />
                Orders
              </span>
            </Link>
          </li>
          {/* orders end */}

          {/* Bill Print */}
          <li className="menu-item" hidden={billPrintHide}>
            <Link to="/bill-print">
              <span>
                <i className="fas fa-print fs-16" />
                Bill Print
              </span>
            </Link>
          </li>
          {/* Bill Print end */}

          {/* Orders report */}
          <li className="menu-item" hidden={orderReportHide}>
            <Link to="/sales-order-report">
              <span>
              <i className="fa fa-paste fs-16" />
                Order Report
              </span>
            </Link>
          </li>
          {/* orders report end */}

          {/* order */}
          {/* <li className="menu-item" hidden={orderHide}>
            <Link to="#" className="has-chevron">
              {" "}
              <span>
                <i className="fa fa-archive fs-16" />
                Orders
              </span>
            </Link>
            <ul
              id="product"
              className="collapse"
              aria-labelledby="product"
              data-parent="#side-nav-accordion"
            >
              <li>
                {" "}
                <Link to="/orders">Orders List</Link>
              </li>

              <li>
                {" "}
                <Link to="/add-order">Add Orders</Link>
              </li>
            </ul>
          </li> */}
          {/* order end */}
          {/* product */}
          <li className="menu-item" hidden={productHide}>
            <Link to="#" className="has-chevron" aria-controls="productMenu">
              {" "}
              <span>
                <i className="fa fa-circle fs-16" />
                Products
              </span>
            </Link>
            <ul
              id="productMenu"
              className="collapse"
              aria-labelledby="productMenu"
              data-parent="#side-nav-accordion"
            >
              <li>
                {" "}
                <Link to="/product-list">Products List</Link>
              </li>

              <li>
                {" "}
                <Link to="/add-product">Add Product</Link>
              </li>
            </ul>
          </li>
          {/* product end */}

          {/* Product Review*/}
          <li className="menu-item" hidden={productReviewHide}>
            <Link to="/product-review">
              {" "}
              <span>
                <i className="fas fa-star fs-16" />
                Product Reviews{" "}
              </span>
            </Link>
          </li>
          {/* Product Review end*/}

          {/* Stock*/}
          <li className="menu-item" hidden={stockHide}>
            <Link to="/stock">
              {" "}
              <span>
                <i className="fa fa-server fs-16" />
                Stocks
              </span>
            </Link>
          </li>
          {/* Stock  End */}

          {/* Stock Summary*/}
          <li className="menu-item" hidden={stockSummaryHide}>
            <Link to="/stock-summary">
              {" "}
              <span>
                <i className="fa fa-server fs-16" />
                Stocks Summary
              </span>
            </Link>
          </li>
          {/* Stock Summary End */}

          {/* Flash Sale*/}
          <li className="menu-item" hidden={flashSaleHide}>
            <Link to="/flash-sale">
              {" "}
              <span>
                <i className="fa fa-tag fs-16" />
                Flash Sale
              </span>
            </Link>
          </li>
          {/* Flash Sale  End */}
          {/* currier */}
          {/* <li className="menu-item" hidden={orderHide}>
            <Link to="#" className="has-chevron">
              {" "}
              <span>
                <i className="fa fa-truck fs-16" />
                Currier
              </span>
            </Link>
            <ul
              id="product"
              className="collapse"
              aria-labelledby="product"
              data-parent="#side-nav-accordion"
            >
              <li>
                {" "}
                <Link to="/currier-company">Currier Company</Link>
              </li>

              <li>
                {" "}
                <Link to="/currier-price">Currier Price</Link>
              </li>
            </ul>
          </li> */}
          {/* currier end */}

          {/* incoming invoice GRN */}
          <li className="menu-item" hidden={grnHide}>
            <Link to="#" className="has-chevron" aria-controls="grnMenu">
              {" "}
              <span>
                <i className="fa fa-archive fs-16" />
                Goods Received Note 
              </span>
            </Link>
            <ul
              id="grnMenu"
              className="collapse"
              aria-labelledby="grnMenu"
              data-parent="#side-nav-accordion"
            >
              <li>
                {" "}
                <Link to="/grn">GRN List</Link>
              </li>

              <li>
                {" "}
                <Link to="/add-grn">Add GRN</Link>
              </li>
            </ul>
          </li>
          {/* incoming invoice  GRN end */}

          {/* incoming invoice GRN */}
          <li className="menu-item" hidden={gdnHide}>
            <Link to="#" className="has-chevron" aria-controls="gdnMenu">
              {" "}
              <span>
                <i className="fa fa-archive fs-16" />
                Goods Dispatch Note 
              </span>
            </Link>
            <ul
              id="gdnMenu"
              className="collapse"
              aria-labelledby="gdnMenu"
              data-parent="#side-nav-accordion"
            >
              <li>
                {" "}
                <Link to="/gdn">GDN List</Link>
              </li>

              <li>
                {" "}
                <Link to="/add-gdn">Add GDN</Link>
              </li>
            </ul>
          </li>
          {/* GDN end */}

          {/* report */}
          <li className="menu-item" hidden={reportHide}>
            <Link to="#" className="has-chevron" aria-controls="reportMenu">
              <span>
                <i className="fa fa-paste fs-16" />
                Report
              </span>
            </Link>
            <ul
              id="reportMenu"
              className="collapse"
              aria-labelledby="reportMenu"
              data-parent="#side-nav-accordion"
            >
              <li>
                <Link to="/sales-profit-report">Profit Report</Link>
              </li>
              <li>
                <Link to="/sales-product-report">Product Report</Link>
              </li>
              <li>
                <Link to="/sales-order-report">Order Report</Link>
              </li>
              {/* <li>
                <Link to="/sales-publisher-products-report">Publisher Wise Products Report</Link>
              </li> */}
              <li>
                <Link to="/sales-students-report">Student Report</Link>
              </li>
              <li>
                <Link to="/sales-total-stock-report">Total Stock Report</Link>
              </li>
            </ul>
          </li>
          {/*  report end*/}

          {/* Total Sale report */}
          <li className="menu-item" hidden={totalSaleReportHide}>
            <Link to="/sales-total-report">
              <span>
              <i className="fa fa-paste fs-16" />
                Total Sales Report
              </span>
            </Link>
          </li>
          {/* Total Sale report end */}

          {/* customers*/}
          <li className="menu-item" hidden={userHide}>
            <Link to="/customer-list">
              {" "}
              <span>
                <i className="fas fa-user-friends fs-16" />
                Customers{" "}
              </span>
            </Link>
          </li>
          {/* customers end*/}


          {/* Category Management */}
          <li className="menu-item" hidden={catHide}>
            <Link to="/category">
              {" "}
              <span>
                <i className="fas fa-folder fs-16" />
                Categories
              </span>
            </Link>
          </li>

          {/* Category Management end */}

          {/* Subject Management */}
          <li className="menu-item" hidden={subjectHide}>
            <Link to="/subject">
              {" "}
              <span>
                <i className="fas fa-folder fs-16" />
                Subjects
              </span>
            </Link>
          </li>
          {/* Subject Management end */}

          {/* Medium Management */}
          <li className="menu-item" hidden={mediumHide}>
            <Link to="/medium">
              {" "}
              <span>
                <i className="fas fa-folder fs-16" />
                Mediums
              </span>
            </Link>
          </li>
          {/* Medium Management end */}

          {/* Publisher Management */}
          <li className="menu-item" hidden={publisherHide}>
            <Link to="/publisher">
              {" "}
              <span>
                <i className="fas fa-folder fs-16" />
                Publishers
              </span>
            </Link>
          </li>
          {/* Publisher Management end */}

          {/* Banner*/}
          {/* <li className="menu-item" hidden={bannerHide}>
            <Link to="/banner">
              {" "}
              <span>
                <i className="fas fa-bookmark fs-16" />
                Banner
              </span>
            </Link>
          </li> */}
          {/* Banner End */}

          {/* Permission */}
          <li className="menu-item" hidden={permissionHide}>
            <Link to="/permission">
              {" "}
              <span>
                <i className="fas fa-exclamation fs-16" />
                Permission
              </span>
            </Link>
          </li>

          {/* Permission End */}
          {/* User*/}
          <li className="menu-item" hidden={adminHide}>
            <Link to="/user-list">
              {" "}
              <span>
                <i className="fas fa-users fs-16" />
                System User
              </span>
            </Link>
          </li>
          {/* User End*/}
          
          {/* Setting*/}
          {/* <li className="menu-item" hidden={settingHide}>
            <Link to="/setting">
              {" "}
              <span>
                <i className="fas fa-wrench fs-16" />
                Settings
              </span>
            </Link>
          </li> */}
          {/* Setting  End */}
          {/* Setting*/}
          <li className="menu-item" hidden={paymentHide}>
            <Link to="/payment">
              {" "}
              <span>
                <i className="fas fa-credit-card fs-16" />
                Payement Log
              </span>
            </Link>
          </li>
        </ul>
        <hr />
        <b style={{ marginBottom: 20, marginLeft: 20 }}>
          Version: V{packageJson.version}
        </b>
      </Scrollbar>
    </div>
  );
}

export default Sidenavigation;